import { TimelineZoomProvider } from "../remotion-timeline/context/timeline-zoom-provider";
import { VideoPreview } from "../video-preview";
import { ActionRow } from "../remotion-timeline/components/action-row";
import { TimelineSizeProvider } from "../remotion-timeline/context/timeline-size-provider";
import {
  ContentWrapper,
  PlayerWrapper,
  BottomWrapper,
  ToolboxWrapper,
  ToolboxButton,
  ButtonIcon,
} from "./styled";
import {
  TimelineContainer,
  Timeline,
} from "../remotion-timeline/components/timeline";
import Transcript from "./transcript";
import Configuration from "./configuration";
import { PlayerRef } from "@remotion/player";
import DesktopTopBar from "./top-bar";
import { useEffect, useState } from "react";
import { getIcon } from "../../../../../utils/get-icon";
import Controllers from "./controllers";
import { Tooltip } from "react-tooltip";

interface Props {
  playerRef: React.RefObject<PlayerRef>;
  timelineContainerRef: React.RefObject<HTMLDivElement>;
  timelineContainerWidth: number | undefined;
}

const MainViewDesktop = ({
  playerRef,
  timelineContainerRef,
  timelineContainerWidth,
}: Props) => {
  const [contentHeight, setContentHeight] = useState(0);
  const [calculatedWidth, setCalculatedWidth] = useState<number | undefined>(
    timelineContainerWidth
  );

  useEffect(() => {
    const updateHeight = () => {
      const timelineHeight = 245;
      const topBarHeight = 60;
      const calculatedHeight =
        window.innerHeight - timelineHeight - topBarHeight;
      setContentHeight(calculatedHeight);
    };

    updateHeight();

    if (!timelineContainerWidth && timelineContainerRef.current) {
      setCalculatedWidth(timelineContainerRef.current.offsetWidth);
    } else {
      setCalculatedWidth(timelineContainerWidth);
    }

    const timeoutId = setTimeout(() => {
      updateHeight();
      if (timelineContainerRef.current) {
        setCalculatedWidth(timelineContainerRef.current.offsetWidth);
      }
    }, 100);

    window.addEventListener("resize", updateHeight);

    return () => {
      window.removeEventListener("resize", updateHeight);
      clearTimeout(timeoutId);
    };
  }, [timelineContainerRef, timelineContainerWidth]);

  useEffect(() => {
    if (timelineContainerWidth) {
      setCalculatedWidth(timelineContainerWidth);
    }
  }, [timelineContainerWidth]);

  return (
    <TimelineZoomProvider initialZoom={1}>
      <DesktopTopBar />
      <ContentWrapper height={contentHeight}>
        <ToolboxWrapper>
          <ToolboxButton active={true}>
            <ButtonIcon
              data-tooltip-id="toolboxSubtitleTooltip"
              data-tooltip-content="Undertekster"
            >
              {getIcon("blogpost")}
            </ButtonIcon>
          </ToolboxButton>
        </ToolboxWrapper>
        <Transcript playerRef={playerRef} />
        <PlayerWrapper>
          <VideoPreview loop playerRef={playerRef} />
          <Controllers playerRef={playerRef} />
        </PlayerWrapper>
        <Configuration />
      </ContentWrapper>
      <BottomWrapper>
        <ActionRow playerRef={playerRef} />
        <TimelineContainer timelineContainerRef={timelineContainerRef}>
          {calculatedWidth ? (
            <TimelineSizeProvider containerWidth={calculatedWidth}>
              <Timeline playerRef={playerRef} />
            </TimelineSizeProvider>
          ) : (
            <div style={{ height: "100%", width: "100%" }} />
          )}
        </TimelineContainer>
      </BottomWrapper>
      <Tooltip id="toolboxSubtitleTooltip" />
    </TimelineZoomProvider>
  );
};

export default MainViewDesktop;
